const keyColor = '#f9604e'

function Logo(props) {
  return (
    <>
      <svg id="torii" data-name="torii" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 600">
        <defs>
          <style>
             @import url("https://fonts.googleapis.com/css?family=Crimson+Pro:700");
             @import url("https://fonts.googleapis.com/css?family=Medula+One");
          </style>
          <filter id="f1" x="0" y="0">
            <feGaussianBlur id="blur1"  stdDeviation="10" />
          </filter>
        </defs>
        <rect width="1000" height="600" fill="#c0f0f3">
          <animate
            attributeName="fill"
              repeatCount="1"
              begin="2s"
              dur="1s"
              fill="freeze"
              to="#24B5A6"
          />
        </rect>
        <g transform="translate(500, 900)">
          <path
            transform="translate(-300, -300)"
            fill={`${keyColor}`}
            d="M594.27,106.5s-81.62,34-301.27,34-288.87-34-288.87-34l9.47,18s9.68,5.15,35.25,11.35l10.42,26.68c0,2,1.9,3.63,4.24,3.63H84.13l9.17,15.89a3.63,3.63,0,0,0,3.63,3.63h72.46l-.87,29.52c-63.88-.81-75.61.52-75.61.52l.39,17a3.64,3.64,0,0,0,3.63,3.63h71l-7.49,254.4h43.32l-7.49-254.4H393l-7.49,254.4h43.32l-7.49-254.4h71a3.64,3.64,0,0,0,3.63-3.63l-1.05-17s-10.29-1.33-74.17-.52l-.87-29.52h72.46a3.63,3.63,0,0,0,3.63-3.63l9.17-15.89h20.62c2.34,0,4.24-1.62,4.24-3.63l10.55-27c24.53-6,33.84-11,33.84-11Zm-200.64,109c-26.84.24-59.49.39-99,.39s-72.16-.15-99-.39l-.88-29.8H394.51Z">
            <animate
              attributeName="d"
              repeatCount="1"
              keyTimes="0; 1"
              calcMode="spline"
              keySplines=".5 0 .5 1"
              begin="1s"
              dur="1s"
              fill="freeze"
              to="M573,116.5s-61.35,39-281,39-275-40-275-40l10,13s7,5,21.85,7.35l10.42,26.68c0,2,1.9,3.63,4.24,3.63H84.13l9.17,15.89a3.63,3.63,0,0,0,3.63,3.63h63.46l-.87,120.52c-63.88-.81-66.61.52-66.61.52l.39,17a3.64,3.64,0,0,0,3.63,3.63h62l-7.49,163.4h68.32l-7.49-163.4H377l-7,163.4h68.11l-7.49-163.4h61.7a3.64,3.64,0,0,0,3.63-3.63l-1.05-17s-1-1.33-64.9-.52l-.87-120.52h63.19a3.63,3.63,0,0,0,3.63-3.63l9.17-15.89h20.62c2.34,0,4.24-1.62,4.24-3.63l10.55-27c11.47-2,15.47-5,15.47-5Zm-195.37,190c-26.84.24-43.49.39-83,.39s-56.16-.15-83-.39l-.88-120.8H378.51Z"
            />
            <animate
              attributeName="fill"
              begin="4.5s"
              dur="1s"
              values={`${keyColor}; #ffffff; ${keyColor}`}
              keyTimes="0; .25; 1"
            />
          </path>
          <animateTransform
            attributeName="transform"
            type="translate"
            additive="sum"
            keyTimes="0; 1"
            calcMode="spline"
            keySplines=".5 0 .5 1"
            begin="0s"
            dur="1s"
            fill="freeze"
            from="0 -100"
            to="0 -600"
          />
          <animateTransform
            attributeName="transform"
            type="scale"
            additive="sum"
            keyTimes="0; 1"
            calcMode="spline"
            keySplines=".5 0 .5 1"
            begin="2s"
            dur="1s"
            fill="freeze"
            from="1 1"
            to="0.25 0.25"
          />
        </g>
        <g>
          <defs>
		    <pattern id="pattern_82AT6k" patternUnits="userSpaceOnUse" width="20" height="20" patternTransform="rotate(90)">
			  <line x1="0" y="0" x2="0" y2="20" stroke="#8BDAEA" strokeWidth="20" />
		    </pattern>
	      </defs>
          <rect width="1000" height="110" y="490" fill="#24B5A6" />
	      <rect width="1000" height="110" y="490" fill="url(#pattern_82AT6k)"  />
          //fill="#E8E5E5"
        </g>
        <g>
          <text x="-848" y="346" fontFamily="Crimson Pro" fontSize="60" fill="white">
            PyCon mini
            <animate
              attributeName="x"
              additive="sum"
              begin="2.1s"
              dur="1s"
              calcMode="spline"
              values="-500; 1000; 980; 1000; 990; 1000; 998; 1000"
              keyTimes="0; 0.8; 0.85; 0.9; 0.97; 0.98; 0.99; 1"
              keySplines='0 0 1 1; 0 0 .5 1; .5 0 1 1; 0 0 .5 1; .5 0 1 1; 0 0 .5 1; .5 0 1 1'
              fill="freeze"
            />
          </text>
        </g>
        <g>
          <text x="1547" y="346" fontFamily="Crimson Pro" fontSize="60" fill="#fff">
            iroshima
            <animate
              attributeName="x"
              additive="sum"
              begin="2.1s"
              dur="1s"
              calcMode="spline"
              values="500; -1000; -980; -1000; -990; -1000; -998; -1000"
              keyTimes="0; 0.8; 0.85; 0.9; 0.97; 0.98; 0.99; 1"
              keySplines='0 0 1 1; 0 0 .5 1; .5 0 1 1; 0 0 .5 1; .5 0 1 1; 0 0 .5 1; .5 0 1 1'
              fill="freeze"
            />
          </text>
        </g>
        <g x="0" y="0" width="100" height="100" filter="url(#f1)" >
          <rect x="0" y="0" width="200" height="100" fill="none"></rect>
          <text fontFamily="Medula One" fontSize="60" textAnchor="middle" fill="white" transform="translate(818, 346)" opacity="0" >
             2019
            <animateTransform
              attributeName="transform"
              type="scale"
              additive="sum"
              keyTimes="0; 1"
              calcMode="spline"
              keySplines="0 0 .5 1"
              begin="3.2s"
              dur="2s"
              fill="freeze"
              from="1.3"
              to="1"
            />
            <animate
              attributeName="opacity"
              begin="3.0s" dur="0.5s"
              from="0" to="1"
              fill="freeze"
            />
          </text>
          <animate
            xlinkHref="#blur1"
            attributeName="stdDeviation"
            begin="3.1s"
            dur="1.0s"
            fill="freeze"
            from="10"
            to="0"
          />
        </g>
      </svg>
    </>)
}
export default Logo

/*
        <g>
          <text x="50%" y="430" font-family="HelveticaNeue-LightItalic" font-size="100" fill="white" textAnchor="middle">
             2019
          </text>
          <rect x="0" y="0" width="1000" height="600" fill="none"></rect>
        </g>
 */
